import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section } from '../Section';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
import { PRICE } from '../../data/content';
const points = [`One-time payment of ${PRICE.today} USD`, 'Instant access', '7-day guarantee'];
export function FinalCta() {
  return <Section data-id="element-116" data-mp="1ens09cnaexo8">
      <div className="mx-auto max-w-2xl text-center" data-id="element-117" data-mp="1en8ipx1jubaq">
        <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-ember sm:text-xs" data-id="element-118" data-mp="1eqnzd4avfse9">
          🔥 The next time you turn on your welder…
        </p>
        <h2 className="mt-2 font-display text-[28px] font-bold uppercase leading-[1.06] text-white sm:text-4xl" data-id="element-119" data-mp="14rf7cgzkgnuj">
          You can keep guessing… or you can start with a clear system
        </h2>
        <p className="mt-4 text-[15px] leading-relaxed text-white/70 sm:text-base" data-id="element-120" data-mp="2z5g7r6arliwq">
          Open Master Welding System™, find the information you need and start
          welding with more confidence, better control and fewer avoidable
          mistakes.
        </p>

        <div className="mt-7" data-id="element-121" data-mp="3tfxy1587a6ul">
          <ScarcityBar data-id="element-122" data-mp="3tempks3t8ax5" />
        </div>

        <div className="mt-6" data-id="element-123" data-mp="3tdldqleyzked">
          <CtaButton label="I want the Master Welding System™" data-id="element-124" data-mp="b1onaejjp5zt" />
          <Countdown className="mt-6" data-id="element-125" data-mp="b39hg31y6mx5" />
        </div>

        <ul className="mx-auto mt-6 space-y-2" data-id="element-126" data-mp="714rbeapk8f9">
          {points.map(point => <li key={point} className="flex items-center justify-center gap-2" data-id="element-127" data-mp="3fevasp5gyqi3">
              <CheckIcon className="h-4 w-4 shrink-0 text-teal-bright" aria-hidden="true" data-id="element-128" data-mp="3ah3gxpl9kub9" />
              <span className="text-[14px] font-semibold text-white/80" data-id="element-129" data-mp="3ohwdsgz1g1hj">
                {point}
              </span>
            </li>)}
        </ul>
      </div>
    </Section>;
}